import { css } from '@emotion/css';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/features';
import { FortuneResultState } from 'src/features/fortune';
import { FortuneHomeControl } from './FortuneHomeControl';
import { NoUserProfile } from './NoUserProfile';
import { FortuneHomePointGet } from './pointGet/FortuneHomePointGet';
import { FortuneHomePointResult } from './pointResult/FortuneHomePointResult';
interface FortuneHomeContentProps {
  pointResult: FortuneResultState;
}

export const FortuneHomeContent: React.FC<FortuneHomeContentProps> = ({ pointResult }) => {
  const { today, pointFactor, currentPoint, userProfile: user } = pointResult;
  const updateStatus = useSelector((state: RootState) => state.fortune.updateStatus);
  // ポイント獲得の通信中、および、獲得アニメーション再生中は二つのボタンを非活性にする
  const isDisabled =
    updateStatus?.state === 'pending' ||
    (updateStatus?.state === 'ok' && !updateStatus.result.animationEnd);
  return (
    <div
      className={css`
        display: flex;
        flex-direction: column;
        height: 100%;
      `}
    >
      <div
        className={css`
          flex: 0 0 auto;
          width: 100%;
          max-width: 480px;
          margin: 24px auto 12px;
          padding: 0 12px;
        `}
      >
        <FortuneHomeControl disabled={isDisabled} />
      </div>

      {(() => {
        if (!user || !pointFactor) {
          return <NoUserProfile />;
        }

        const userInfo = {
          name: user.mPNm,
          imageUrl: user.mJpeg || '',
          birthday: user.mBirth
        };

        if (today) {
          return (
            <FortuneHomePointResult
              pointFactor={pointFactor}
              commentId={today.commentId}
              current={currentPoint}
            />
          );
        } else {
          return <FortuneHomePointGet pointFactor={pointFactor} userInfo={userInfo} />;
        }
      })()}
    </div>
  );
};
